import { useTranslation } from "@/i18n";
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: number;
  className?: string;
  label?: string;
}

/**
 * Calm SVG spinner. No marketing flair — production-dashboard look.
 */
export function LoadingSpinner({
  size = 20,
  className,
  label,
}: LoadingSpinnerProps) {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t("shared.loading.default");
  return (
    <div
      role="status"
      aria-label={resolvedLabel}
      className={cn("inline-flex items-center gap-2", className)}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="animate-spin text-ocean-600"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeOpacity="0.2"
          strokeWidth="3"
        />
        <path
          d="M22 12a10 10 0 0 1-10 10"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      <span className="sr-only">{resolvedLabel}</span>
    </div>
  );
}
